/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeContentListItems.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Content List Item constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *  
 *  Created:    Monday, July 4, 2022 - 3:30 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      07/04/2022  NJN     File Created
 *      
 *  Copyright (c) 2022 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const UPDATE_CONTENTLISTID = 'UPDATE_CONTENTLISTID';